import { logError as rumLogError } from '@ps-int/ufo-rocks/lib/helpers/rum';

import { MetrikaParam } from './metrika';
import isOnPremise from './onpremise/is-onpremise';

export interface LogErrorOptions {
    block?: string;
    message?: string;
    level?: 'error' | 'warning' | 'critical';
    method?: string;
    type?: string;
    source?: string;

    additional?: {
        kind?: string;
    } & Record<string, unknown>;
    metrikaName?: string;
    metrikaParams?: MetrikaParam[];
}

export interface SafeLogErrorOptions extends LogErrorOptions {
    method: string;
}

/**
 * @param {Object} options
 * @param {Error} error
 */
export default function logError(options: LogErrorOptions, error: Error) {
    if (isOnPremise) {
        return;
    }

    rumLogError(options, error);
}
